module.exports = __webpack_public_path__ + "img/icon_coin.6b486495.png";